module.exports = __webpack_public_path__ + "static/img/chelianwang.efa3ef06.png";